// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics, logEvent } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBvr4vSxiLCpfybLewtoeVPHH5Z8JJvd34",
  authDomain: "oak-beam-software-development.firebaseapp.com",
  projectId: "oak-beam-software-development",
  storageBucket: "oak-beam-software-development.appspot.com",
  messagingSenderId: "695860522816",
  appId: "1:695860522816:web:140f5f669739a3073b54a5",
  measurementId: "G-HG410VRJZN"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
logEvent(analytics, 'broj_posjeta');